/* DailyKickz - zwevende winkelwagenknop op de productpagina.
   De balk gebruikt de gewone knop en maatkeuze van de pagina, dus alles wat daar werkt (winkelmandje, maatkeuze) werkt hier ook. */
(function () {
  if (window.dkSticky) { window.dkSticky.init(); return; }
  var huidig = null;

  function q(s, r) { return (r || document).querySelector(s); }

  function start() {
    var root = q('[data-dksa]');
    var info = q('product-info[id^="MainProduct-"]') || q('product-info');
    if (!root || !info) return null;
    var c = root.dataset;
    var knop = q('.dksa__knop', root), tekst = q('.dksa__knop-tekst', root), sel = q('.dksa__maat', root), wrap = q('.dksa__maatwrap', root), txt = q('.dksa__maattekst', root);
    var nu = q('.dksa__nu', root), was = q('.dksa__was', root);
    var zichtbaar = false, wacht = 0, scrolWacht = 0, mo = null;

    function hoofdknop() { return info.querySelector('.product-form__submit'); }
    function maten() {
      var fs = info.querySelectorAll('variant-selects fieldset');
      return fs.length === 1 ? Array.prototype.slice.call(fs[0].querySelectorAll('input[type="radio"]')) : [];
    }

    function zetTekst() { var o = sel.options[sel.selectedIndex]; if (txt) txt.textContent = o ? o.text : ''; }

    function sync() {
      var b = hoofdknop();
      var uit = !b || b.hasAttribute('disabled');
      var laden = !!b && !uit && (b.classList.contains('loading') || b.getAttribute('aria-disabled') === 'true');
      knop.disabled = uit;
      knop.classList.toggle('is-laden', laden);
      knop.setAttribute('aria-busy', laden ? 'true' : 'false');
      tekst.textContent = uit ? c.uit : c.label;

      var n = info.querySelector('.dk-price__now'), w = info.querySelector('.dk-price__was');
      if (n && nu) nu.textContent = n.textContent.trim();
      if (was && n) { was.hidden = !w; was.textContent = w ? w.textContent.trim() : ''; }

      if (!sel || c.maat !== 'true') return;
      var rs = maten();
      if (rs.length < 2) { wrap.hidden = true; root.classList.add('dksa--geen-maat'); return; }
      var sig = rs.map(function (r) { return r.value + (r.classList.contains('disabled') ? '0' : '1'); }).join('|');
      if (sel.getAttribute('data-sig') !== sig) {
        sel.innerHTML = '';
        rs.forEach(function (r) {
          var o = document.createElement('option');
          o.value = r.value;
          o.textContent = (c.maatVoor ? c.maatVoor + ' ' : '') + r.value + (r.classList.contains('disabled') && c.maatUit ? ' – ' + c.maatUit : '');
          sel.appendChild(o);
        });
        sel.setAttribute('data-sig', sig);
      }
      var gekozen = rs.filter(function (r) { return r.checked; })[0];
      if (gekozen) sel.value = gekozen.value;
      zetTekst();
      wrap.hidden = false;
      root.classList.remove('dksa--geen-maat');
    }

    function ruimte() {
      var h = document.documentElement;
      if (c.ruimte !== 'true') return;
      var onder = parseFloat(getComputedStyle(root).bottom) || 0;
      h.style.setProperty('--dksa-ruimte', zichtbaar ? Math.round(root.offsetHeight + onder) + 'px' : '0px');
      h.classList.toggle('dksa-aan', zichtbaar);
    }

    function toon() {
      var vis;
      if (c.editor === 'true') vis = true;
      else {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var pct = max > 0 ? (window.pageYOffset / max) * 100 : 0;
        var na = parseFloat(c.na); if (isNaN(na)) na = 40;
        vis = zichtbaar ? pct >= na - 2 : pct >= na;
      }
      if (vis !== zichtbaar) {
        zichtbaar = vis;
        root.classList.toggle('is-zichtbaar', vis);
        root.setAttribute('aria-hidden', vis ? 'false' : 'true');
        ruimte();
      }
    }

    function planSync() { clearTimeout(wacht); wacht = setTimeout(function () { sync(); toon(); }, 40); }
    function planScroll() { if (scrolWacht) return; scrolWacht = setTimeout(function () { scrolWacht = 0; toon(); }, 30); }

    function opKnop() {
      var b = hoofdknop();
      if (!b || b.disabled || knop.classList.contains('is-laden')) return;
      b.click();
      planSync();
    }
    function opMaat() {
      zetTekst();
      var rs = maten();
      for (var i = 0; i < rs.length; i++) { if (rs[i].value === sel.value) { rs[i].click(); break; } }
      planSync();
    }

    knop.addEventListener('click', opKnop);
    if (sel) sel.addEventListener('change', opMaat);
    window.addEventListener('scroll', planScroll, { passive: true });
    window.addEventListener('resize', planScroll);
    info.addEventListener('change', planSync);
    mo = new MutationObserver(planSync);
    mo.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], characterData: true });

    sync(); toon();
    setTimeout(function () { sync(); toon(); }, 400);

    return {
      stop: function () {
        clearTimeout(wacht); clearTimeout(scrolWacht);
        window.removeEventListener('scroll', planScroll); window.removeEventListener('resize', planScroll);
        info.removeEventListener('change', planSync);
        if (mo) mo.disconnect();
        document.documentElement.classList.remove('dksa-aan');
        document.documentElement.style.removeProperty('--dksa-ruimte');
      }
    };
  }

  function init() { if (huidig) huidig.stop(); huidig = start(); }
  window.dkSticky = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { if (huidig) { huidig.stop(); huidig = null; } });
})();